import { render, staticRenderFns } from "./interviews.vue?vue&type=template&id=af947574&scoped=true&"
import script from "./interviews.vue?vue&type=script&lang=js&"
export * from "./interviews.vue?vue&type=script&lang=js&"
import style0 from "./interviews.vue?vue&type=style&index=0&id=af947574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af947574",
  null
  
)

export default component.exports